import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbsComponent } from '@shared/ui-components/breadcrumbs/breadcrumbs.component';
import { BreadcrumbItem } from '@shared/ui-components/breadcrumbs/shared/breadcrumb-item';

@Component({
  selector: 'evland-public-offer',
  templateUrl: './public-offer.component.html',
  styleUrls: [ './public-offer.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BreadcrumbsComponent,
  ],
})
export class PublicOfferComponent {
  breadcrumbs: BreadcrumbItem[] = [
    { routerLink: '/public-offer', label: $localize`Договір публічної оферти` }
  ];

  #titleService = inject(Title);

  constructor() {
    this.#titleService.setTitle(`${$localize`Договір публічної оферти`} | evland ${new Date().getFullYear()}`);
  }
}
